/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LikelyBenefits = {
    type: 'array',
    contains: {
        type: 'LikelyBenefit',
    },
};